const stats = [
  { value: '500+', label: '赛事覆盖', icon: 'ri-trophy-line', desc: '涵盖全球各大体育赛事' },
  { value: '200万+', label: '活跃用户', icon: 'ri-user-star-line', desc: '来自全国各地的体育爱好者' },
  { value: '50+', label: '专业分析师', icon: 'ri-team-line', desc: '资深体育分析师团队' },
  { value: '98%', label: '预测准确率', icon: 'ri-percent-line', desc: '行业领先的赛事预测水准' },
];

export default function StatsSection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="flex flex-col items-center text-center p-6 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100/70 text-accent-600 mb-3">
                <i className={`${stat.icon} text-lg`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">{stat.value}</div>
              <div className="text-sm font-semibold text-foreground-700 mt-1">{stat.label}</div>
              <p className="text-foreground-400 text-xs mt-1">{stat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}